import baseModule from './baseModule'
class Credit extends baseModule('credit') {}
const vuexData = new Credit()

export default { ...vuexData }
